module.exports = __webpack_public_path__ + "img/img_05.7c1eaa31.jpg";